export const headers = [
  { field: "id", headerName: "Codigo", width: 150 },
  {
    field: "aju_fecha",
    headerName: "Fecha",
    width: 130,
    valueGetter: (params) => {
      const date = new Date(params.row.aju_fecha);
      return date.toLocaleDateString('es-ES'); // Formato DD/MM/YYYY
    },
  },
  { field: "sel_fullname", headerName: "Vendedor", width:230 },
  { field: "totalinventario", headerName: "Total", width: 100 },
];